import { render } from "./MailAutoReply.vue?vue&type=template&id=8af29a5c&scoped=true"
import script from "./MailAutoReply.vue?vue&type=script&lang=js"
export * from "./MailAutoReply.vue?vue&type=script&lang=js"

import "./MailAutoReply.vue?vue&type=style&index=0&id=8af29a5c&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8af29a5c"]])

export default __exports__